import { getService } from 'data/function';
import { catchAction } from '../EventReceiver';
import { EventAction } from '../EventAction';
import { AccountFeatures } from 'modules/account/AccountFeatures';
export class AccountProcessor {
    static get AuthenticationService() {
        return getService('AuthenticationService');
    }
    static get AccountService2() {
        return getService('AccountService2');
    }
    static async process({ message, trackingProperties, source }) {
        let response;
        switch (catchAction(message.action)) {
            case EventAction.GetAccount:
                response = await this.getAccount(trackingProperties);
                break;
            case EventAction.InviteUser:
                response = await this.inviteUser(message.content, trackingProperties);
                break;
            case EventAction.GetToken:
                response = this.getToken(trackingProperties);
                break;
        }
        source.postMessage(response, '*');
    }
    static getAccount(trackingProperties) {
        return {
            response: AccountProcessor.AuthenticationService.getAccount(),
            trackingProperties,
        };
    }
    static getToken(trackingProperties) {
        return {
            response: AccountProcessor.AuthenticationService.token,
            trackingProperties,
        };
    }
    static async inviteUser(newUser, trackingProperties) {
        try {
            if (this.isBlipAccountEnabled === undefined) {
                this.isBlipAccountEnabled = await AccountFeatures.isBlipAccountEnabled();
            }
            if (this.isBlipAccountEnabled) {
                await this.AccountService2.inviteUser(newUser);
            }
            return {
                trackingProperties,
            };
        }
        catch (err) {
            return {
                trackingProperties,
                error: err,
            };
        }
    }
}
